export enum TipoDocumento {
  CEDULA_CIUDADANIA = 1,
  NIT = 2,
  CEDULA_EXTRANJERIA = 3,
}

export enum EstadoUsuarioFront {
  ACTIVO = 'activo',
  BLOQUEADO = 'bloqueado',
  PRE_REGISTRO = 'pre_registro',
}

export enum TipoPago {
    RECARGA_CONDUCE_Y_VIVE = 1,
    PASA_PAGA_Y_TOLIS = 2,
    SIN_SELECCIONAR = 3,
    RECARGA_AUTOMATICA = 4,
}

export enum TipoTransaccion {
    PASO = 1,
    RECARGA = 2,
    AJUSTE_DEBITO = 3,
    AJUSTE_CREDITO = 4,
    PASO_SUSCRIPCION = 5,
    PAGO_POR_SUSCRIPCION = 6,
    PAGO_MIXTO = 7,
    REGISTRO_MEDIO_PAGO = 8,
    CAMBIO_FORMA_PAGO = 9,
    COMPRA = 10,
    NOTA_DEBITO_MANUAL = 11,
    NOTA_CREDITO_MANUAL = 12,
    PAGO_INMEDIATO_RECHAZADO = 13,
    NOTA_DEBITO_PAGO_INMEDIATO_RECHAZADO = 14,
  }

  export enum EstadoTransaccion {
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    PENDING = "PENDING",
    APPROVED_PARTIAL = "APPROVED_PARTIAL",
    PARTIAL_EXPIRED = "PARTIAL_EXPIRED",
}

export enum TipoSesionPlaceToPay {
  PAGO_UNICO = '1',
  SUSCRIPCION = '2',
  PAGO_SUSCRIPCION = '3',
}

export enum EstadoUsuarioEmpresa {
    ACTIVO = 'activo',
    SUSPENDIDO = 'suspendido',
    BLOQUEADO = 'bloqueado',
    PRE_REGISTRO = 'pre_registro',
}

export enum TipoUsuario {
    USUARIO_FRONT = 1,
    USUARIO_EMPRESARIAL = 2,
    USUARIO_ADMINISTRADOR = 3,
}

export enum TipoReporte {
    REPORTE_MOVIMIENTOS_USUARIO = 'REPORTE DE MOVIMIENTOS',
    REPORTE_EXTRACTO_USUARIO = 'REPORTE EXTRACTO',
}
